import React, { useState, useEffect } from "react";
import "./Footer.css";
import blog1 from "../../Assets/footer_blog.png";
import blog from "../../Assets/blog_footer2.png";
import phone from "../../Assets/footer_phone.png";
import email from "../../Assets/footer_email.png";
import address from "../../Assets/footer_address.png";
import arrow from "../../Assets/link_arrow.png";
import phone_circle from "../../Assets/phone_circle.png";
import { Link } from "react-router-dom";
import Loader from "../Sign/Loader";
import axios from "axios";
import slugify from "slugify";

function Footer() {
  const [filteredRelatedPostData, setFilteredRelatedPostData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsCountPerPages, setitemsCountPerPages] = useState(0);
  const [lastpage, setlastpage] = useState(0);
  const [blogsdata, setblogsdata] = useState("");

  const extractDateFromUpdatedAt = (updated_at) => {
    if (updated_at) {
      const datePart = updated_at.split("T")[0];
      return datePart;
    }
    return null;
  };

  useEffect(() => {
    getblogsdata();
  }, [currentPage]);

  const getblogsdata = () => {
    axios
      .get(`/api/posts?page=${currentPage}`)
      .then((res) => {
        setblogsdata(res.data);
        setFilteredRelatedPostData(res.data.data);
        setTotalPages(res?.data?.total);
        setitemsCountPerPages(res?.data?.per_page);
        setlastpage(res?.data?.last_page);
      })
      .catch((error) => {
        console.error("Error fetching blog data:", error);
      });
  };

  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling
    });
  };

  return (
    <div className="main_footer">
      <footer className="footer">
        <div className="container">
          <div className="upper_footer">
            <div className="d-flex flex-row">
              <div className="col-xl-5 col-lg-5 upper_main pl-5">
                Get your Free Business Consultation
              </div>
              <div className="col-xl-2 col-lg-2">
                <img
                  className="phone_circle"
                  src={phone_circle}
                  alt="phonecircle"
                />
              </div>
              <div className="col-xl-4 col-lg-5">
                <p className="uperfotter_phone">+1 959-210-0950</p>
                <p className="uperfotter_phone1">info@stopshoprei.com</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-md-6 footer-col">
              <h4 className="footer_heading">About Company</h4>
              <p className="sub_contact_detail">
                StopShopREI is committed to staying ahead of the curve,
                continuously adapting to the ever-evolving real estate
                landscape. We envision a future where every real estate has
                access to the tools and knowledge they need to succeed in a
                competitive market.
              </p>
              <div className="social-links">
                <a
                  href="https://www.facebook.com/stopshoprei"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  href="https://www.instagram.com/stopshoprei/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/stopshoprei/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 footer-col">
              <h4 className="footer_heading">Quick link</h4>
              <ul className="ql">
                <li>
                  <Link
                    to="/about-us"
                    className="contact_ushref"
                    onClick={scrollToTop}
                  >
                    <span>
                      <img className="pr-2 ql_links" src={arrow} alt="arrow" />
                    </span>
                    About Us
                  </Link>
                </li>
                <li>
                  <a href="/#id_feedback" onClick={scrollToTop}>
                    <span>
                      <img className="pr-2 ql_links" src={arrow} alt="arrow" />
                    </span>
                    Client Feedback
                  </a>
                </li>
                <li>
                  <a href="/#id_questions" onClick={scrollToTop}>
                    <span>
                      <img className="pr-2 ql_links" src={arrow} alt="arrow" />
                    </span>
                    Our Services
                  </a>
                </li>
                <li>
                  <Link
                    to="/contact-us"
                    className="contact_ushref"
                    onClick={scrollToTop}
                  >
                    <span>
                      <img className="pr-2 ql_links" src={arrow} alt="arrow" />
                    </span>
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms-conditions"
                    className="contact_ushref"
                    onClick={scrollToTop}
                  >
                    <span>
                      <img className="pr-2 ql_links" src={arrow} alt="arrow" />
                    </span>
                    Terms and Conditions
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy-policy"
                    className="contact_ushref"
                    onClick={scrollToTop}
                  >
                    <span>
                      <img className="pr-2 ql_links" src={arrow} alt="arrow" />
                    </span>
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/earnings-disclaimer"
                    className="contact_ushref"
                    onClick={scrollToTop}
                  >
                    <span>
                      <img className="pr-2 ql_links" src={arrow} alt="arrow" />
                    </span>
                    Earnings Disclaimer
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-xl-3 col-md-6 footer-col">
              <h4 className="footer_heading">Recent Posts</h4>
              <div>
                {filteredRelatedPostData ? (
                  filteredRelatedPostData
                    .sort(
                      (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    )
                    .slice(0, 2)
                    .map((data) => (
                      <div className="related_post_div" key={data.id}>
                        <Link
                          to={`/blogs/${data.id}/${slugify(data.title, {
                            lower: true,
                          })}`}
                          onClick={scrollToTop}
                        >
                          <div className="row">
                            <div className="col-lg-4 col-md-4 col-3">
                              <img
                                className="image_related_post"
                                src={data?.image_url}
                                alt="blog post"
                              />
                            </div>
                            <div className="col-lg-8 col-md-8 col-8">
                              <p className="desp_related_post">
                                {data?.created_at
                                  ? extractDateFromUpdatedAt(data?.created_at)
                                  : null}
                              </p>
                              <p className="heading_related_post1">
                                {data?.title}
                              </p>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))
                ) : (
                  <Loader />
                )}
              </div>
            </div>
            <div className="col-xl-3 col-md-6 footer-col">
              <h4 className="footer_heading">Contact Details</h4>
              <h2 className="sub_contact">Phone Number</h2>
              <div className="d-flex flex-row">
                <img className="p-2 contact_img" src={phone} alt="phone" />
                <div className="p-2 sub_contact_detail">+1 959-210-0950</div>
              </div>
              <h2 className="sub_contact">Email Address</h2>
              <div className="d-flex flex-row">
                <img className="p-2 contact_img" src={email} alt="email" />
                <div className="p-2 sub_contact_detail">
                  info@stopshoprei.com
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer_last p-3">
        © 2025 StopShopRei. All Rights Reserved.
      </div>
    </div>
  );
}

export default Footer;
